module.exports = __webpack_public_path__ + "media/images/icons/twotone/video-camera-d6807ff4a03cae2d6702cd83b4d77be4.svg";